function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14 2.667v10.666c0 .369-.298.667-.667.667H2.667C2.298 14 2 13.702 2 13.333v-5.11c0-.145.047-.285.133-.4L6.3 2.266c.126-.168.323-.267.533-.267h6.5c.369 0 .667.298.667.667zm-2 .666H7.5c-.21 0-.407.1-.533.267l-3.5 4.667c-.087.115-.134.256-.134.4V12c0 .368.299.667.667.667h8c.368 0 .667-.299.667-.667V4c0-.368-.299-.667-.667-.667z",
  transform: "translate(-170 -543) translate(16 254) translate(0 61) translate(16 228) translate(138)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.668 5.333v1.334H4V5.333h2.667zM6 0c.368 0 .667.298.667.667V4c0 .368-.299.667-.667.667H.668c-.55 0-.863-.628-.533-1.067l2.5-3.333C2.76.099 2.958 0 3.168 0zm-.666 1.333H3.5l-1.5 2h3.334v-2z",
  transform: "translate(-170 -543) translate(16 254) translate(0 61) translate(16 228) translate(138) translate(5.332 4)"
}))))))));

function SvgIconDoors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoors);
export default __webpack_public_path__ + "static/media/icon-doors.c40b264d.svg";
export { ForwardRef as ReactComponent };